export const TOKEN = 'authorization'
export const MENU = 'menu'
export const ENTITY = 'entity'

// 路由path相关变量
export const ROUTES = {
  layout: 'layout',
  index: '/index',
  entity: '/entity',
  entity_manage: '/entity/manage',
  entity_vip:'/entity/vip',
  user: '/user',
  user_manage: '/user/manage',
  wechat_manage: '/user/wechatManage',
  sys: '/system',
  sys_pmsn: '/system/permission',
  sys_pmsn_menu: '/system/permission/menu',
  sys_pmsn_menu_role: '/system/permission/menu_role',
  sys_pmsn_role: '/system/permission/role',
  car: '/car',
  car_manage: '/car/manage',
  car_add: '/car/add',
  car_type: '/car/type',
  car_voice: '/car/voice',
  data_monitor:'/car/dataMonitor',
  data_monitor_info:'/car/dataMonitorInfo',
  car_app_manage:'/car/car_app_manage',
  file: '/file',
  file_map: '/file/map',
  file_router: '/file/router',
  remote: '/remote',
  monitor:'/monitor',
  car_monitor:'/monitor/carMonitor',
  lease:'/lease',
  order:'/lease/order',
  consultation:'/user/consultation',
  message:'/user/message',
  apk:'/apk',
  apk_add:'/apk/add',
  apk_manage:'/apk/manage',
  work:'/work',
  work_manage:'/work/manage',
  work_multiManage:'/work/multiManage',
  data:'/data',
  data_clear:'/data/clear',
  report:'/report',
  report_analysis:'/report/analysis',
  alarm_manage:'/car/alarm',
  consumables:'/car/consumables'
}
